import React from "react";
import ProjectsPage from "../../components/Projects";

export default function Projects() {
  return <ProjectsPage />;
}
